<template>
    <div class="w-full">
        <div v-if="itemsCurrent.length" class="w-full flex flex-wrap">
            <div
                v-for="(reference, index) in itemsCurrent"
                :key="reference.id"
                class="w-1/2 md:w-4/12 lg:w-1/4 xl:w-1/4 px-2 py-4"
            >
                <div class="relative">
                    <img
                        v-img:group
                        v-img-loading
                        loading="lazy"
                        :src="reference.images[0].url | image"
                        :alt="reference.images[0].alt"
                        class="rounded-lg border border-stack-primary w-full"
                    />
                    <div v-if="enabled" class="absolute top-2 right-2">
                        <app-button danger icon @click="remove(index)">
                            🗑
                        </app-button>
                    </div>
                </div>
                <div
                    class="bg-brand-blue flex items-center rounded-lg max-w-24 pl-2 py-2"
                >
                    <div class="flex flex-wrap text-white">
                        <div class="w-full flex justify-between">
                            <div class="flex flex-col">
                                <span>
                                    Prod
                                    <router-link
                                        :to="`/app/products/detail/${reference.product.id}`"
                                        class="btn-a p-0"
                                    >
                                        {{
                                            reference.product.sku ||
                                            `ID ${reference.productId}`
                                        }}
                                    </router-link>
                                    | Ref
                                    <router-link
                                        :to="`/app/products/detail/${reference.product.id}?reference=${reference.id}&tab=references`"
                                        class="btn-a p-0"
                                    >
                                        {{
                                            reference.barcode ||
                                            `ID ${reference.id}`
                                        }}
                                    </router-link>
                                </span>
                            </div>
                        </div>
                        <div class="w-full md:w-1/2 mt-2 flex flex-col">
                            <strong>Color </strong>
                            <div class="flex items-center">
                                <span class="capitalize">
                                    {{ reference.color }}
                                </span>
                                <div
                                    class="ml-1 w-5 h-5 rounded-full border border-theme-border"
                                    :style="{
                                        'background-color': reference.colorRef
                                    }"
                                ></div>
                            </div>
                        </div>
                        <div class="w-full md:w-1/2 mt-2 flex flex-col">
                            <strong>Tamaño </strong>
                            <span class="capitalize">
                                {{ reference.size }}
                            </span>
                        </div>
                        <div class="w-full mt-2 flex flex-col">
                            <strong>Precio actual </strong>
                            <div class="flex items-center">
                                <span>
                                    {{ reference.priceOffer | money }}
                                </span>
                                <span class="ml-2 line-through">
                                    {{ reference.priceOffer | money }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="w-10/12 mx-auto py-3">
            <span class="text-lg">{{ emptyMessage }}</span>
        </div>
    </div>
</template>

<script>
import { DEFAULT_IMAGE_URL } from "@/common/constants";

export default {
    name: "ReferencesCards",
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            required: true,
            default: () => [
                {
                    id: 72,
                    size: "27-28",
                    color: "amarillo",
                    colorRef: "#f1c232",
                    product: {
                        name: "Botas para la lluvia de con sapito",
                        slug: "botas-para-la-lluvia-de-con-sapito",
                        brand: {
                            slug: "calzado-importado",
                            name: "Calzado Importado"
                        }
                    },
                    images: [
                        {
                            id: 128,
                            url: DEFAULT_IMAGE_URL,
                            alt: "Bota de niño de sapito",
                            sequence: {
                                sequence: 0
                            }
                        }
                    ]
                }
            ]
        },
        emptyMessage: {
            type: String,
            required: false,
            default: () =>
                "Nuestro sistema NO encuentra referencias asociadas 0️⃣."
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({}),
    methods: {
        remove(fromIndex) {
            let items = [...this.itemsCurrent];
            items.splice(fromIndex, 1);
            this.$emit("change", items);
        }
    }
};
</script>
